import {Box, Button, IconButton, makeStyles, Tooltip} from "@material-ui/core";
import {useStylesTooltip} from "../../../../../config/theme";
import {useCallback, useState} from "react";
import {CSVLink} from "react-csv";
import UtilService from "../../../../../helper/service";
import { useSelector } from "react-redux";

const useStyles = makeStyles(() => ({
  collapseMenu: {
    boxShadow: '0px 0px 4px #00000033',
    background: 'white'
  },
  addTagBtn: {
    fontFamily: 'roboto-regular',
    backgroundColor: '#0179EE',
    borderRadius: 6,
    fontSize: 14,
    boxShadow: 'none',
    textTransform: 'none'
  },
  removeTagBtn: {
    backgroundColor: '#F0F0F0',
    borderRadius: 6,
    fontSize: 14,
    fontFamily: 'roboto-regular',
    color: '#697683',
    boxShadow: 'none',
    textTransform: 'none',
    '&:hover': {
      backgroundColor: '#d6d6d6'
    }
  },
  actionBtn: {
    fontFamily: 'roboto-regular',
    fontSize: 14,
    color: '#697683',
    boxShadow: 'none',
    textTransform: 'none'
  },
  participantsCount: {
    fontFamily: 'roboto-regular',
    fontSize: 14,
    color: '#606B76',
  }
}));

interface IProps {
  onAddTags: () => void;
  onRemoveTags: () => void;
  onRemoveParticipants: () => void;
  onClearSelected: () => void;
  selectedParticipants: any[];
}

const csvHeadersWithEmail = [
  { label: "Email", key: "email" },
  { label: "Tags", key: "tags" }
];

const ParticipantListDetailHeader = (props: IProps) => {
  const classes = useStyles();
  const {
    onAddTags, onRemoveTags, onRemoveParticipants, onClearSelected, selectedParticipants
  } = props;
  const tooltipClasses = useStylesTooltip();
  const { totalListParticipants } = useSelector((state: any) => state.participantList);
  const [csvData, setCSVData] = useState<any[]>([]);

  const onDownloadCSV = () => {
    if (!selectedParticipants.length) return;
    const downData = selectedParticipants.map((p: any) => Object.assign({}, {
      email: p.email,
      tags: p.tags ? UtilService.getParsedTags(p.tags) : '-',
    }));
    setCSVData(downData);
  };

  const showActionButtons = useCallback(() => {
    return selectedParticipants.length > 0;
  }, [selectedParticipants]);

  const isEditable = useCallback(() => {
    const editable = localStorage.getItem('listEditable') ? localStorage.getItem('listEditable') : '';
    return editable === 'true';
  }, [localStorage]);

  return (
    <div>
      <Box className={classes.collapseMenu} display="flex" justifyContent="space-between" alignItems="center">
        <Box display="flex" alignContent="flex-start" alignItems="center" pl={3}>
          {(!showActionButtons() && totalListParticipants !== 0) && (
            <Box p={1} className={classes.participantsCount}>
              {totalListParticipants} {totalListParticipants > 1 ? ' Participants' : ' Participant'}
            </Box>
          )}
          {showActionButtons() && (
            <>
              <Box p={1}><Button id='add_tags_button' variant="contained" className={classes.addTagBtn} color="primary" onClick={() => onAddTags()}>Add Tags</Button></Box>
              <Box p={1}><Button id='remove_tags_button' variant="contained" className={classes.removeTagBtn} color="secondary" onClick={() => onRemoveTags()}>Remove Tags</Button></Box>
              {isEditable() && <Box p={1}><Button className={classes.actionBtn} onClick={() => onRemoveParticipants()}>Remove Participants From List</Button></Box>}
            </>
          )}
        </Box>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          {showActionButtons() && (
            <Box p={1}><Button className={classes.actionBtn} onClick={onClearSelected}>Clear Selected</Button></Box>
          )}
          <Box p={1} style={showActionButtons() ? {} : { visibility: 'hidden' }}>
            <Tooltip classes={tooltipClasses} title="Export to CSV" placement="bottom" arrow>
              <CSVLink data={csvData} headers={csvHeadersWithEmail} filename={`participants.csv`}>
                <IconButton
                  aria-label="download"
                  size="medium"
                  onClick={onDownloadCSV}
                >
                  <img src={'/assets/icons/download_icon.svg'} alt="CSV Download" />
                </IconButton>
              </CSVLink>
            </Tooltip>
          </Box>
        </Box>
      </Box>
    </div>
  )
};

export default ParticipantListDetailHeader;
